"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as a } from "react";
import l from "../components/Icon/SvgIcon.js";
const t = (e) => /* @__PURE__ */ o(
  l,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.25 9.54a2.34 2.34 0 0 1 2.336-2.341H7.17c.647 0 1.231-.359 1.525-.937l.466-.919a.17.17 0 0 1 .151-.093h5.295c.09 0 .174.05.217.13l.501.923c.3.553.876.896 1.503.896h1.586A2.34 2.34 0 0 1 20.75 9.54v6.919a2.34 2.34 0 0 1-2.336 2.34H5.586a2.34 2.34 0 0 1-2.336-2.34zm2.336 10.509h12.828A3.59 3.59 0 0 0 22 16.459V9.54a3.59 3.59 0 0 0-3.586-3.591h-1.586a.46.46 0 0 1-.404-.241l-.5-.924A1.5 1.5 0 0 0 14.607 4H9.312c-.536 0-1.02.297-1.265.776l-.467.92a.46.46 0 0 1-.41.253H5.586A3.59 3.59 0 0 0 2 9.54v6.919a3.59 3.59 0 0 0 3.586 3.59M4.599 9.54a.987.987 0 1 0 1.973 0 .99.99 0 0 0-.986-.99.99.99 0 0 0-.987.99M12 9.67a3.329 3.329 0 0 0 0 6.658 3.329 3.329 0 0 0 0-6.657m0 7.908a4.58 4.58 0 0 1-4.572-4.58A4.58 4.58 0 0 1 12 8.422 4.58 4.58 0 0 1 16.572 13 4.58 4.58 0 0 1 12 17.578m-1.349-4.579c0-.746.606-1.352 1.35-1.352a1.352 1.352 0 0 1 0 2.704A1.35 1.35 0 0 1 10.65 13M9.4 13a2.604 2.604 0 0 0 2.6 2.602A2.604 2.604 0 0 0 14.598 13 2.603 2.603 0 0 0 12 10.397 2.603 2.603 0 0 0 9.401 13",
        clipRule: "evenodd"
      }
    )
  }
), n = a(t);
export {
  n as PhotoCenter,
  n as default
};
